import Button from '@mui/material/Button';

import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ApartmentIcon from '@mui/icons-material/Apartment';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';

import { theme } from '../../../theme';

const NAV_ITEMS = [
    {
        key: 'INSTAFIX_TO_CUSTOMER_PAYMENT_INVOICE',
        label: 'Instafix To Customer',
        icon: <ApartmentIcon />,
    },
    {
        key: 'FTM_TO_CUSTOMER_PAYMENT_INVOICE',
        label: 'Tradesperson To Customer',
        icon: <BusinessCenterIcon />,
    },
    {
        key: 'INSTAFIX_TO_FTM_PAYMENT_INVOICE',
        label: 'Instafix To Tradesperson',
        icon: <MiscellaneousServicesIcon />,
    },
];

const selectedStyle = {
    backgroundColor: theme.main_code,
    color: '#fff',
};

const NavBtn = ({ invoiceType, setInvoiceType }) => (
    <div className="col-lg-12 col-md-12 my-sm-auto ms-sm-auto me-sm-0 mx-auto mt-3">
        <div className="nav-wrapper position-relative end-0">
            <ul className="nav nav-pills nav-fill p-1" role="tablist">
                {NAV_ITEMS.map(({ key, label, icon }) => (
                    <li className="nav-item" key={key}>
                        <Button
                            className="nav-link mb-0 px-0 py-1 active"
                            startIcon={icon}
                            onClick={() => setInvoiceType(key)}
                            style={invoiceType === key ? selectedStyle : undefined}
                        >
                            {label}
                        </Button>
                    </li>
                ))}
            </ul>
        </div>
    </div>
);

export default NavBtn;